/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { fetchBase, fetchInterceptor, fetchController } from "./utils/Fetcher";
import FetchError from "./utils/FetchError";
import FetchSuccess from "./utils/FetchSuccess";

export const fetchV2 = async (url, request, options) => {
  const fetchArgs = fetchInterceptor(2, url, request, options);
  return await fetchBase(...fetchArgs);
};

export const fetchV3 = async (url, request, options) => {
  const fetchArgs = fetchInterceptor(3, url, request, {
    eventTarget: null,
    ...options,
  });

  return await fetchBase(...fetchArgs);
};

export const toJSON = async (response) => {
  if (response instanceof Response) {
    return await response.clone().json();
  }

  return response;
};

export { fetchBase, FetchError, FetchSuccess, fetchController };
